import React, { useEffect, useState } from "react";
import "./preparingOrderStyle.css";
import { useSelector } from "react-redux";
import ColumnBackgroundMedia from "../columnBackgroundMedia/ColumnBackgroundMedia";

const PreparingOrderCard = () => {
  const { fontSize, fontColor, prepareFontBG,prepareBG,kotTokenData, showPreparingTimer, prepareColumnBgEnabled, prepareColumnBgOpacity, prepareColumnBgMediaIds, columnBgIntervalMs } = useSelector(
    (state) => state.kotTokenDisplaySlice
  );
  const rawData = kotTokenData?.preparing;
  const data = Array.isArray(rawData) ? rawData : [];
  const fontSizeStyles =
    fontSize === "xlarge"
      ? { fontSize: "46px" }
      : fontSize === "large"
      ? { fontSize: "38px" }
      : { fontSize: "30px" };
  const columns = fontSize === "large" || fontSize === "xlarge" ? 2 : 3;
// autoscroll
const chunkSize = fontSize === "xlarge" ? 16 : fontSize === "medium" ? 36 : 20;
const totalChunks = Math.ceil(data.length / chunkSize);
const [currentChunk, setCurrentChunk] = useState(0);

// Get the current data slice
const chunkData = data.slice(
  currentChunk * chunkSize,
  currentChunk * chunkSize + chunkSize
);

  const [timers, setTimers] = useState({});

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    try {
      const saved = localStorage.getItem("preparingTimers");
      if (saved) setTimers(JSON.parse(saved));
    } catch (_) {}
  }, []);

  useEffect(() => {
    if (!showPreparingTimer) return;
    const interval = setInterval(() => {
      setTimers((prev) => {
        const updated = { ...prev };
        chunkData.forEach((res) => {
          const key = res?.transNo;
          if (key != null) {
            updated[key] = (updated[key] || 0) + 1;
          }
        });
        try {
          localStorage.setItem("preparingTimers", JSON.stringify(updated));
        } catch (_) {}
        return updated;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [chunkData, showPreparingTimer]);
useEffect(() => {
  if (data.length <= chunkSize) return;
  const interval = setInterval(() => {
    setCurrentChunk((prev) => (prev + 1) % totalChunks);
  }, 7000); // scroll every 10 seconds
  return () => clearInterval(interval);
}, [data.length, chunkSize]);


  return (
    <div className="preparing-card-container">
      <div className="order-status-type-container">
        <h3 className="token-display-status-header" style={{padding:"10px 0"}}>PREPARING</h3>
      </div>
      <div style={{backgroundColor:prepareBG, height:"-webkit-fill-available", position: "relative", overflow: "hidden"}}>
      {prepareColumnBgEnabled && Array.isArray(prepareColumnBgMediaIds) && prepareColumnBgMediaIds.length > 0 && (
        <ColumnBackgroundMedia mediaIds={prepareColumnBgMediaIds} opacityPercent={prepareColumnBgOpacity} intervalMs={columnBgIntervalMs} />
      )}
      <div className="token-status-card-body"
      style={{
        ...fontSizeStyles,
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: fontSize === "xlarge" ? "14px" : "12px",
        padding: fontSize === "xlarge" ? "14px" : "10px",
        position: "relative",
        zIndex: 1,
        
      }}>
      
        {chunkData?.map((res, i) => (
              <div key={i}>
                <div className="token-number-box" style={{ textAlign:"center", backgroundColor: prepareFontBG ,color: fontColor}}>
                  <div>{res?.transNo}</div>
                  {showPreparingTimer && (
                    <div style={{ fontSize: fontSize === "xlarge" ? "16px" : "12px", fontWeight: "bold" }}>
                      {formatTime(timers[res?.transNo] || 0)}
                    </div>
                  )}
                </div>
              </div>
            ))}
   
      </div>
      </div>
    </div>
  );
};

export default PreparingOrderCard;
